import moment from "moment";
import classNames from "classnames";
// React
import React from "react";
// Components
import DatePicker from "common/ui/components/datePicker/DatePicker";
import FetchingWrapper from "common/ui/loading/FetchingWrapper";
// Helpers
import DateHelper from "common/utils/DateHelper";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./ReportDatePicker.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class ReportDatePicker extends React.Component {
    render() {
        const { onSelect, fromDate, toDate, dateRange, dateLimit, className, allowCustomRanges, isFetching } = this.props;
        let dateRanges = dateRange;
        if (!dateRange) {
            dateRanges = {
                'Yesterday': DateHelper.getYesterday(),
                'Last 7 Days': DateHelper.getLast7Days(),
                'Last 30 Days': DateHelper.getLast30Days(),
                'This Month': DateHelper.getThisMonth(),
                'Last Month': DateHelper.getLastMonth()
            };
        }
        let dateRangeLimit = dateLimit;
        if (!dateLimit) {
            dateRangeLimit = null; //{ month: 6 };
        }
        return (React.createElement(FetchingWrapper, { isFetching: isFetching },
            React.createElement(DatePicker, { onSelect: onSelect, fromDate: fromDate, toDate: toDate, isDisabled: this.props.isDisabled, minDate: "09/01/2015", maxDate: moment().subtract(1, 'day'), ranges: dateRanges, dateLimit: dateRangeLimit, allowCustomRanges: allowCustomRanges, className: classNames(styles.datePicker, className) })));
    }
}
